import type { SVGProps } from 'react';
const SvgHouse = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M11.535 3.115c.34-.179.76-.15 1.072.09l10.5 8-1.213 1.59-1.893-1.443V21H13v-6h-2v6H4.001v-9.647l-1.894 1.443-1.212-1.592 10.5-8zM6.001 9.83V19H9v-6h6v6h3.001V9.83l-6-4.572z"
    />
  </svg>
);
export default SvgHouse;
